/**
 * @param {object} props
 * @param {string | number} [props.label]
 * @param {number} [props.size]
 * @returns {React.JSX.Element}
 */
export function ClusterSymbol({ size = 40, label = '' }) {
  const halfSize = size / 2;
  const radius = halfSize;

  return (
    <div style={{ position: 'relative' }}>
      <svg height={size} width={size}>
        <circle cx={halfSize} cy={halfSize} r={radius} fill="var(--viking-royal-blue)" />
      </svg>
      <div
        className="vikingMapMarker"
        style={{
          display: 'flex',
          position: 'absolute',
          inset: 0,
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '16px',
          letterSpacing: '0px',
        }}
      >
        {label}
      </div>
    </div>
  );
}
